__turbopack_context__.v({
  "arrow": "WorkflowDialog-module__b1g0Qa__arrow",
  "boxContainer": "WorkflowDialog-module__b1g0Qa__boxContainer",
  "boxContent": "WorkflowDialog-module__b1g0Qa__boxContent",
  "boxHeader": "WorkflowDialog-module__b1g0Qa__boxHeader",
  "dialogContent": "WorkflowDialog-module__b1g0Qa__dialogContent",
  "dialogInnerContent": "WorkflowDialog-module__b1g0Qa__dialogInnerContent",
  "list": "WorkflowDialog-module__b1g0Qa__list",
  "workflowTitleInput": "WorkflowDialog-module__b1g0Qa__workflowTitleInput",
});
